import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/lib/api/api-error.js';

import { DEFAULT_GC_TIME_MS, shouldRetry } from './policies.js';

/**
 * Единый QueryClient приложения.
 *
 * staleTime намеренно НЕ задан глобально: у эндпоинтов этого API она различается
 * принципиально (личные данные — ноль, справочники — минуты), и общий дефолт означал бы,
 * что каждый вызов обязан его переопределять, а забытое переопределение показывало бы
 * устаревшую подписку. Политики живут в policies.ts и подключаются явно.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: DEFAULT_GC_TIME_MS,
        // Обновление токена уже делает apiFetch прозрачно, поэтому 401 сюда доходит
        // только как окончательный отказ — повторять его бессмысленно.
        retry: (failureCount, error) =>
          shouldRetry(failureCount, error instanceof ApiError ? error.status : 0),
        // Возврат на вкладку не должен дёргать сеть сам по себе: страницы, которым нужна
        // свежесть, получают её через staleTime: 0 из policies.ts.
        refetchOnWindowFocus: false,
      },
      mutations: {
        // Мутация не идемпотентна: повтор оплаты или смены пароля недопустим.
        retry: false,
      },
    },
  });
}
